import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '@app/services/authentication.service';
import { User } from './_models/user';
import { SessionService } from './services/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  currentUser: User;
  sessionStarted: boolean = false;
  Fixed: boolean = false;
  
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private session: SessionService
  ) {
      this.authenticationService.currentUser.subscribe(value => this.currentUser = value);
      this.session.sessionInitialized.subscribe(status => this.sessionStarted = status);
  }

  ngOnInit(): void {
    if ((this.currentUser) && (!this.sessionStarted)) {
      this.session.initSession(this.currentUser.facility_id);
    }
  }

  logout() {
      this.authenticationService.logout();
      this.sessionStarted = false;
      this.router.navigate(['/login']);
  }

}
